export const errorList = {
  '-380': {
    message: '用户被锁定'
  },
  '-370': {
    message: '用户被锁定'
  },
  '-360': {
    message: 'token错误'
  },
  '-340': {
    message: '用户在其他地方登录'
  },
  '-320': {
    message: '不是用户的授信设备'
  },
  '-300': {
    message: 'token已过期'
  },
  '-280': {
    message: '用户被锁定'
  },
  '-270': {
    message: '上行短信尚未收到'
  },
  '-260': {
    message: '手机动态密码错误'
  },
  '-250': {
    message: '手机号未绑定'
  },
  '-220': {
    message: '接口已升级'
  },
  '-200': {
    message: '请求解析错误'
  },
  '-180': {
    message: '签名错误'
  },
  '-164': {
    message: 'UNKNOW_TOKEN_DENIE'
  },
  '-161': {
    message: 'USER_CHECK_FAILED'
  },
  '-160': {
    message: '访问被拒绝'
  },
  '-140': {
    message: '参数错误'
  },
  '-120': {
    message: 'mt参数服务端无法识别'
  },
  '-108': {
    message: 'DUBBO_SERVICE_TIMEOUT_ERROR'
  },
  '-107': {
    message: 'DUBBO_SERVICE_NOTFOUND_ERROR'
  },
  '-106': {
    message: 'SECURITY_SERVICE_ERROR'
  },
  '-105': {
    message: 'WEB_ACCESS_FAILE'
  },
  '-104': {
    message: 'FATAL_ERROR'
  },
  '-103': {
    message: 'IP_DENIED'
  },
  '-102': {
    message: 'SERIALIZE_FAILED'
  },
  '-101': {
    message: 'INTERNAL_SERVER_ERROR'
  },
  '-100': {
    message: '服务端返回未知错误'
  },
  '-2147483648': {
    message: '未分配返回值'
  }
}
